(function () {
  "use strict";

  var STORAGE_KEY = "evlg-warenbestand-anfragekorb-v1";
  var numberFormatter = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 });

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalize(value) {
    return String(value == null ? "" : value)
      .toLocaleLowerCase("de-DE")
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function formatNumber(value) {
    return numberFormatter.format(Number(value) || 0);
  }

  function initials(value) {
    var words = String(value || "EVLG").replace(/[()/-]+/g, " ").split(/\s+/).filter(Boolean);
    if (!words.length) return "EV";
    if (words.length === 1) return words[0].slice(0, 3).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  function loadCart() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveCart(cart) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
    } catch (error) {
      /* The current page session can still use the in-memory cart. */
    }
  }

  function initInventory(root) {
    if (root.dataset.inventoryInitialized === "true") return;
    root.dataset.inventoryInitialized = "true";

    var catalog = window.EVLG_INVENTORY_CATALOG_DATA;
    var grid = root.querySelector("[data-product-grid]");
    if (!catalog || !Array.isArray(catalog.products)) {
      grid.innerHTML = '<div class="inventory-empty"><h3>Die Lagerdaten konnten nicht geladen werden.</h3><p>Bitte laden Sie die Seite erneut.</p></div>';
      grid.setAttribute("aria-busy", "false");
      return;
    }

    var products = catalog.products;
    var productById = new Map(products.map(function (product) { return [product.id, product]; }));
    var categoryById = new Map(catalog.meta.categories.map(function (category) { return [category.id, category]; }));
    var brandById = new Map();
    catalog.meta.categories.forEach(function (category) {
      category.brands.forEach(function (brand) {
        brandById.set(brand.id, Object.assign({ categoryId: category.id, categoryLabel: category.label }, brand));
      });
    });
    var logoById = new Map(
      ((catalog.meta.logoSprite && catalog.meta.logoSprite.entries) || []).map(function (logo) {
        return [logo.id, logo];
      })
    );

    var pageSize = Number(root.dataset.pageSize) || 24;
    var visibleLimit = pageSize;
    var state = {
      query: "",
      categoryId: "",
      brandId: "",
      productType: "",
      viscosity: "",
      packageType: "",
      availability: "available",
      sort: "available",
    };

    var cart = loadCart().filter(function (item) { return productById.has(item.id); });
    var lastFocusedElement = null;

    var categoryGrid = root.querySelector("[data-category-grid]");
    var brandPanel = root.querySelector("[data-brand-panel]");
    var brandPanelTitle = root.querySelector("[data-brand-panel-title]");
    var brandGrid = root.querySelector("[data-brand-grid]");
    var searchInput = root.querySelector("[data-search-input]");
    var resultsSection = root.querySelector("[data-results-section]");
    var resultsTitle = root.querySelector("[data-results-title]");
    var resultCount = root.querySelector("[data-result-count]");
    var liveStatus = root.querySelector("[data-live-status]");
    var emptyState = root.querySelector("[data-empty-state]");
    var loadMoreWrap = root.querySelector("[data-load-more-wrap]");
    var productModal = root.querySelector("[data-product-modal]");
    var productModalContent = root.querySelector("[data-product-modal-content]");
    var checkoutModal = root.querySelector("[data-checkout-modal]");
    var cartDrawer = root.querySelector("[data-cart-drawer]");
    var overlay = root.querySelector("[data-overlay]");
    var cartItems = root.querySelector("[data-cart-items]");
    var cartEmpty = root.querySelector("[data-cart-empty]");
    var cartFooter = root.querySelector("[data-cart-footer]");
    var cartSummaryNode = root.querySelector("[data-cart-summary]");
    var orderPreview = root.querySelector("[data-order-preview]");
    var orderBody = root.querySelector("[data-order-body]");
    var orderForm = root.querySelector(".inventory-order-form");

    function brandVisualMarkup(logoId, label, className) {
      var logo = logoById.get(logoId);
      var sprite = catalog.meta.logoSprite;
      var spriteUrl = root.dataset.logoSpriteUrl || "";
      if (logo && Number.isInteger(logo.index) && sprite && spriteUrl) {
        var columns = Math.max(1, Number(sprite.columns) || 1);
        var rows = Math.max(1, Number(sprite.rows) || 1);
        var column = logo.index % columns;
        var row = Math.floor(logo.index / columns);
        return '<span class="' + className + '" role="img" aria-label="' + escapeHtml(label) + '">' +
          '<img src="' + escapeHtml(spriteUrl) + '" alt="" decoding="async" style="position:absolute;display:block;width:' + (columns * 100) + '%;height:' + (rows * 100) + '%;max-width:none;left:-' + (column * 100) + '%;top:-' + (row * 100) + '%;">' +
        '</span>';
      }
      return '<span class="' + className + '">' + escapeHtml(initials(label)) + "</span>";
    }

    function renderCategories() {
      categoryGrid.innerHTML = catalog.meta.categories.map(function (category, index) {
        var marks = ["ÖL", "OEM", "PRO", "WK"];
        var active = state.categoryId === category.id ? " is-active" : "";
        return '<button class="inventory-category-card' + active + '" type="button" data-category-select="' + escapeHtml(category.id) + '">' +
          '<span class="inventory-category-card__mark" aria-hidden="true">' + marks[index % marks.length] + "</span>" +
          "<div><h3>" + escapeHtml(category.label) + '</h3><span>Auswahl öffnen →</span></div>' +
        "</button>";
      }).join("");
    }

    function renderBrands(categoryId) {
      var category = categoryById.get(categoryId);
      if (!category) {
        brandPanel.hidden = true;
        brandGrid.innerHTML = "";
        return;
      }
      brandPanelTitle.textContent = category.label;
      brandGrid.innerHTML = category.brands.map(function (brand) {
        var active = state.brandId === brand.id ? " is-active" : "";
        return '<button class="inventory-brand-card' + active + '" type="button" data-brand-select="' + escapeHtml(brand.id) + '">' +
          brandVisualMarkup(brand.id, brand.label, "inventory-brand-card__initials") +
          "<strong>" + escapeHtml(brand.label) + "</strong>" +
        "</button>";
      }).join("");
      brandPanel.hidden = false;
    }

    function populateSelect(filterName, values) {
      var select = root.querySelector('[data-filter="' + filterName + '"]');
      if (!select) return;
      var first = select.options[0].outerHTML;
      select.innerHTML = first + values.map(function (value) {
        var optionValue = typeof value === "string" ? value : value.id;
        var optionLabel = typeof value === "string" ? value : value.label;
        return '<option value="' + escapeHtml(optionValue) + '">' + escapeHtml(optionLabel) + "</option>";
      }).join("");
    }

    populateSelect(
      "brandId",
      Array.from(brandById.values()).sort(function (a, b) {
        return a.label.localeCompare(b.label, "de", { sensitivity: "base" });
      })
    );
    populateSelect("productType", catalog.meta.filterValues.productTypes);
    populateSelect("viscosity", catalog.meta.filterValues.viscosities);
    populateSelect("packageType", catalog.meta.filterValues.packageTypes);

    function hasActiveSelection() {
      return Boolean(
        state.query
        || state.brandId
        || state.productType
        || state.viscosity
        || state.packageType
      );
    }

    function directBrandFromQuery(query) {
      var queryTokens = normalize(query).split(" ").filter(Boolean);
      if (!queryTokens.length) return "";
      var candidates = Array.from(brandById.values()).map(function (brand) {
        return {
          id: brand.id,
          tokens: normalize(brand.label).split(" ").filter(Boolean),
        };
      }).sort(function (a, b) { return b.tokens.length - a.tokens.length; });
      var match = candidates.find(function (candidate) {
        return candidate.tokens.length <= queryTokens.length
          && candidate.tokens.every(function (token, index) { return queryTokens[index] === token; });
      });
      return match ? match.id : "";
    }

    function filterProducts() {
      var queryTokens = normalize(state.query).split(" ").filter(Boolean);
      var directQueryBrandId = directBrandFromQuery(state.query);
      var filtered = products.filter(function (product) {
        if (directQueryBrandId && product.brandId !== directQueryBrandId) return false;
        if (queryTokens.length) {
          var haystackTokenList = normalize(product.searchText).split(" ").filter(Boolean);
          var haystackTokens = new Set(haystackTokenList);
          if (!queryTokens.every(function (token) {
            if (haystackTokens.has(token)) return true;
            return haystackTokenList.some(function (candidate) {
              if (/[0-9]/.test(token)) return candidate.indexOf(token) !== -1;
              return token.length >= 3 && candidate.indexOf(token) === 0;
            });
          })) return false;
        }
        if (state.categoryId && product.categoryId !== state.categoryId) return false;
        if (state.brandId && product.brandId !== state.brandId) return false;
        if (state.productType && product.productType !== state.productType) return false;
        if (state.viscosity && product.viscosity !== state.viscosity) return false;
        if (state.packageType && product.packageType !== state.packageType) return false;
        if (state.availability === "available" && !product.available) return false;
        return true;
      });

      filtered.sort(function (a, b) {
        if (state.sort === "stock-desc") {
          return b.stockQuantity - a.stockQuantity || a.title.localeCompare(b.title, "de", { numeric: true });
        }
        if (state.sort === "brand") {
          return a.brand.localeCompare(b.brand, "de") || a.title.localeCompare(b.title, "de", { numeric: true });
        }
        if (state.sort === "title") {
          return a.title.localeCompare(b.title, "de", { numeric: true, sensitivity: "base" });
        }
        return Number(b.available) - Number(a.available)
          || a.brand.localeCompare(b.brand, "de")
          || a.title.localeCompare(b.title, "de", { numeric: true, sensitivity: "base" });
      });
      return filtered;
    }

    function stockStatusMarkup(product) {
      if (product.available) {
        return '<span class="inventory-stock-pill inventory-stock-pill--available">Verfügbar</span>';
      }
      return '<span class="inventory-stock-pill inventory-stock-pill--unavailable">Derzeit nicht verfügbar</span>';
    }

    function productTagsMarkup(product) {
      return [product.productType, product.viscosity, product.packageType, product.packageSize, product.clothingSize]
        .filter(Boolean)
        .map(function (value) {
          return '<span class="inventory-product-tag">' + escapeHtml(value) + "</span>";
        }).join("");
    }

    function cardMarkup(product) {
      var manufacturerNumber = product.manufacturerArticleNo || "nicht angegeben";
      var actionLabel = product.available ? "In die Anfrage" : "Verfügbarkeit anfragen";
      return '<article class="inventory-product-card" itemscope itemtype="https://schema.org/Product">' +
        '<div class="inventory-product-card__stripe"></div>' +
        '<div class="inventory-product-card__image">' + brandVisualMarkup(product.logoId || product.brandId, product.subBrand || product.brand, "inventory-product-brand") + "</div>" +
        '<div class="inventory-product-card__body">' +
          '<meta itemprop="brand" content="' + escapeHtml(product.brand) + '">' +
          '<div class="inventory-product-card__eyebrow"><span class="inventory-product-card__area">' + escapeHtml(product.category) + "</span>" + stockStatusMarkup(product) + "</div>" +
          '<h3 itemprop="name">' + escapeHtml(product.title) + "</h3>" +
          '<p class="inventory-product-card__variant">' + escapeHtml(product.family || product.productType) + "</p>" +
          '<div class="inventory-product-tags">' + productTagsMarkup(product) + "</div>" +
          '<div class="inventory-product-card__codes">' +
            '<div><span>EVLG Artikel-Nr.</span><strong itemprop="sku">' + escapeHtml(product.articleNo) + "</strong></div>" +
            '<div><span>Hersteller-Nr.</span><strong>' + escapeHtml(manufacturerNumber) + "</strong></div>" +
          "</div>" +
          '<div class="inventory-product-card__stock">' +
            '<div><strong>' + formatNumber(product.stockQuantity) + " " + escapeHtml(product.stockUnit) + '</strong><span>verfügbarer Lagerbestand</span></div>' +
            '<span>' + escapeHtml(product.packageType + (product.packageSize ? " · " + product.packageSize : "")) + "</span>" +
          "</div>" +
          '<div class="inventory-product-card__actions">' +
            '<button class="inventory-button inventory-button--primary" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">' + actionLabel + "</button>" +
            '<button class="inventory-detail-button" type="button" data-product-detail="' + escapeHtml(product.id) + '" aria-label="Details zu ' + escapeHtml(product.title) + '">i</button>' +
          "</div>" +
        "</div>" +
      "</article>";
    }

    function updateResultsHeading(filtered) {
      var title = "Ihre Produktauswahl";
      if (state.brandId && brandById.has(state.brandId)) title = brandById.get(state.brandId).label;
      else if (state.query) title = 'Suchergebnisse für „' + state.query + '“';
      else if (state.categoryId && categoryById.has(state.categoryId)) title = categoryById.get(state.categoryId).label;
      resultsTitle.textContent = title;
      resultCount.textContent = formatNumber(filtered.length);
    }

    function renderProducts(announce) {
      renderCategories();
      if (state.categoryId) renderBrands(state.categoryId);

      if (!hasActiveSelection()) {
        resultsSection.hidden = true;
        grid.innerHTML = "";
        grid.setAttribute("aria-busy", "false");
        emptyState.hidden = true;
        loadMoreWrap.hidden = true;
        return;
      }

      var filtered = filterProducts();
      var visible = filtered.slice(0, visibleLimit);
      resultsSection.hidden = false;
      updateResultsHeading(filtered);
      grid.innerHTML = visible.map(cardMarkup).join("");
      grid.setAttribute("aria-busy", "false");
      emptyState.hidden = filtered.length !== 0;
      loadMoreWrap.hidden = filtered.length <= visibleLimit;
      if (announce) {
        liveStatus.textContent = formatNumber(filtered.length) + " Produkte gefunden. " + formatNumber(visible.length) + " werden angezeigt.";
      }
    }

    function syncFilterControls() {
      root.querySelectorAll("[data-filter]").forEach(function (select) {
        var key = select.dataset.filter;
        select.value = state[key] || "";
      });
      root.querySelectorAll("[data-stock-mode]").forEach(function (button) {
        var active = button.dataset.stockMode === state.availability;
        button.setAttribute("aria-pressed", active ? "true" : "false");
        button.classList.toggle("is-active", active);
      });
      root.querySelector("[data-sort]").value = state.sort;
    }

    function resetAll() {
      state.query = "";
      state.categoryId = "";
      state.brandId = "";
      state.productType = "";
      state.viscosity = "";
      state.packageType = "";
      state.availability = "available";
      state.sort = "available";
      visibleLimit = pageSize;
      searchInput.value = "";
      brandPanel.hidden = true;
      syncFilterControls();
      renderProducts(true);
      root.querySelector("[data-category-grid]").scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function publicStockText(product) {
      return product.available
        ? formatNumber(product.stockQuantity) + " " + product.stockUnit + " verfügbar"
        : "derzeit nicht verfügbar";
    }

    function maximumQuantity(product) {
      return product.available ? Math.max(1, Number(product.stockQuantity) || 1) : 9999;
    }

    function sanitizeQuantity(product, value) {
      var quantity = Math.floor(Number(value) || 1);
      return Math.min(maximumQuantity(product), Math.max(1, quantity));
    }

    function addToCart(id) {
      var product = productById.get(id);
      if (!product) return;
      var existing = cart.find(function (item) { return item.id === id; });
      if (existing) existing.quantity = sanitizeQuantity(product, existing.quantity + 1);
      else cart.push({ id: id, quantity: 1 });
      saveCart(cart);
      renderCart();
      liveStatus.textContent = product.title + " wurde in den Anfragekorb gelegt.";
      openCart();
    }

    function cartRows() {
      return cart.map(function (item) {
        var product = productById.get(item.id);
        return product ? { item: item, product: product } : null;
      }).filter(Boolean);
    }

    function renderCart() {
      var rows = cartRows();
      root.querySelectorAll("[data-cart-count]").forEach(function (node) {
        node.textContent = String(rows.length);
      });

      cartEmpty.hidden = rows.length !== 0;
      cartFooter.hidden = rows.length === 0;
      cartItems.innerHTML = rows.map(function (row) {
        var product = row.product;
        var item = row.item;
        return '<article class="inventory-cart-item">' +
          "<div><h3>" + escapeHtml(product.title) + "</h3>" +
            '<p class="inventory-cart-item__code">EVLG Artikel-Nr. ' + escapeHtml(product.articleNo) + "</p>" +
            '<p class="inventory-cart-stock">' + escapeHtml(publicStockText(product)) + "</p>" +
            '<button class="inventory-cart-item__remove" type="button" data-cart-remove="' + escapeHtml(product.id) + '">Entfernen</button>' +
          "</div>" +
          '<div class="inventory-cart-item__controls">' +
            '<label>Menge in ' + escapeHtml(product.stockUnit) +
              '<input type="number" inputmode="numeric" min="1" max="' + maximumQuantity(product) + '" step="1" value="' + item.quantity + '" data-cart-quantity="' + escapeHtml(product.id) + '">' +
            "</label>" +
          "</div>" +
        "</article>";
      }).join("");

      if (cartSummaryNode) {
        cartSummaryNode.textContent = rows.length + (rows.length === 1 ? " Position" : " Positionen");
      }
      renderOrderPreview();
    }

    function orderLines() {
      return cartRows().map(function (row, index) {
        var product = row.product;
        var manufacturerNumber = product.manufacturerArticleNo || "nicht angegeben";
        return [
          (index + 1) + ". " + row.item.quantity + " " + product.stockUnit + " – " + product.title,
          "   EVLG Artikel-Nr.: " + product.articleNo,
          "   Hersteller-Nr.: " + manufacturerNumber,
          "   Lagerstatus bei Anfrage: " + publicStockText(product),
        ].join("\n");
      });
    }

    function renderOrderPreview() {
      var rows = cartRows();
      orderPreview.innerHTML = rows.map(function (row) {
        return '<div class="inventory-order-preview__item"><span>' + row.item.quantity + " " + escapeHtml(row.product.stockUnit) + " · " + escapeHtml(row.product.title) + "</span><strong>" + escapeHtml(row.product.articleNo) + "</strong></div>";
      }).join("") + '<p class="inventory-order-preview__total">Der Lagerbestand wird vor der Auftragsbestätigung erneut geprüft.</p>';

      if (orderBody) {
        orderBody.value = [
          "LAGERVERKAUFSANFRAGE ÜBER SHOP.EVLG.DE",
          "",
          "Ausgewählte Positionen:",
          ...orderLines(),
          "",
          "Hinweis: Die angezeigten Lagerwerte sind eine Momentaufnahme und noch keine Reservierung.",
        ].join("\n");
      }
    }

    function setBodyLock(locked) {
      document.body.classList.toggle("inventory-lock-scroll", locked);
    }

    function openCart() {
      lastFocusedElement = document.activeElement;
      cartDrawer.classList.add("is-open");
      cartDrawer.setAttribute("aria-hidden", "false");
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add("is-open"); });
      setBodyLock(true);
      var closeButton = cartDrawer.querySelector("[data-cart-close]");
      if (closeButton) closeButton.focus();
    }

    function closeCart(restoreFocus) {
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      overlay.classList.remove("is-open");
      window.setTimeout(function () {
        if (!cartDrawer.classList.contains("is-open")) overlay.hidden = true;
      }, 220);
      setBodyLock(false);
      if (restoreFocus && lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
    }

    function openModal(modal) {
      if (!modal) return;
      lastFocusedElement = document.activeElement;
      closeCart(false);
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      setBodyLock(true);
      var closeButton = modal.querySelector(".inventory-modal__close");
      if (closeButton) closeButton.focus();
    }

    function closeModal(modal, restoreFocus) {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      setBodyLock(false);
      if (restoreFocus && lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
    }

    function productDetailMarkup(product) {
      var manufacturerNumber = product.manufacturerArticleNo || "nicht angegeben";
      return '<article class="inventory-product-detail">' +
        '<span class="inventory-kicker">' + escapeHtml(product.category) + "</span>" +
        brandVisualMarkup(product.logoId || product.brandId, product.subBrand || product.brand, "inventory-product-detail__brand") +
        '<h2 id="InventoryProductModalTitle-' + escapeHtml(root.dataset.sectionId) + '">' + escapeHtml(product.title) + "</h2>" +
        '<p class="inventory-product-detail__subtitle">' + escapeHtml(product.family + (product.viscosity ? " · " + product.viscosity : "")) + "</p>" +
        '<div class="inventory-product-detail__grid">' +
          '<div class="inventory-product-detail__panel"><dl>' +
            "<dt>Hauptmarke</dt><dd>" + escapeHtml(product.brand) + "</dd>" +
            "<dt>Untermarke</dt><dd>" + escapeHtml(product.subBrand || "–") + "</dd>" +
            "<dt>Produktart</dt><dd>" + escapeHtml(product.productType) + "</dd>" +
            "<dt>Viskosität/Klasse</dt><dd>" + escapeHtml(product.viscosity || "–") + "</dd>" +
            "<dt>Gebinde</dt><dd>" + escapeHtml(product.packageType + (product.packageSize ? " · " + product.packageSize : "")) + "</dd>" +
            "<dt>EVLG Artikel-Nr.</dt><dd>" + escapeHtml(product.articleNo) + "</dd>" +
            "<dt>Hersteller-Nr.</dt><dd>" + escapeHtml(manufacturerNumber) + "</dd>" +
          "</dl></div>" +
          '<div class="inventory-product-detail__availability">' +
            stockStatusMarkup(product) +
            "<strong>" + formatNumber(product.stockQuantity) + " " + escapeHtml(product.stockUnit) + "</strong>" +
            "<span>Verfügbarer Bestand laut aktueller Lagerliste. Zwischenverkauf vorbehalten.</span>" +
            '<button class="inventory-button inventory-button--primary inventory-button--wide" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">' + (product.available ? "In die Anfrage" : "Verfügbarkeit anfragen") + "</button>" +
          "</div>" +
        "</div>" +
      "</article>";
    }

    function showProduct(id) {
      var product = productById.get(id);
      if (!product) return;
      productModalContent.innerHTML = productDetailMarkup(product);
      openModal(productModal);
    }

    categoryGrid.addEventListener("click", function (event) {
      var button = event.target.closest("[data-category-select]");
      if (!button) return;
      state.categoryId = button.dataset.categorySelect;
      state.brandId = "";
      visibleLimit = pageSize;
      syncFilterControls();
      renderCategories();
      renderBrands(state.categoryId);
      resultsSection.hidden = true;
      brandPanel.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    brandGrid.addEventListener("click", function (event) {
      var button = event.target.closest("[data-brand-select]");
      if (!button) return;
      state.brandId = button.dataset.brandSelect;
      var brand = brandById.get(state.brandId);
      if (brand) state.categoryId = brand.categoryId;
      visibleLimit = pageSize;
      syncFilterControls();
      renderProducts(true);
      resultsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    root.querySelector("[data-category-back]").addEventListener("click", function () {
      state.categoryId = "";
      state.brandId = "";
      brandPanel.hidden = true;
      syncFilterControls();
      renderProducts(false);
      categoryGrid.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    searchInput.addEventListener("input", function () {
      state.query = searchInput.value.trim();
      visibleLimit = pageSize;
      renderProducts(false);
    });

    searchInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        state.query = searchInput.value.trim();
        renderProducts(true);
        if (!resultsSection.hidden) resultsSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    root.querySelector("[data-search-clear]").addEventListener("click", function () {
      state.query = "";
      searchInput.value = "";
      searchInput.focus();
      renderProducts(true);
    });

    root.querySelectorAll("[data-filter]").forEach(function (select) {
      select.addEventListener("change", function () {
        var key = select.dataset.filter;
        state[key] = select.value;
        if (key === "brandId" && state.brandId) {
          var brand = brandById.get(state.brandId);
          if (brand) {
            state.categoryId = brand.categoryId;
            renderBrands(state.categoryId);
          }
        }
        visibleLimit = pageSize;
        renderProducts(true);
      });
    });

    root.querySelectorAll("[data-stock-mode]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.availability = button.dataset.stockMode === "all" ? "all" : "available";
        visibleLimit = pageSize;
        syncFilterControls();
        renderProducts(true);
      });
    });

    root.querySelector("[data-sort]").addEventListener("change", function (event) {
      state.sort = event.target.value;
      renderProducts(false);
    });

    root.querySelectorAll("[data-reset-filters]").forEach(function (button) {
      button.addEventListener("click", resetAll);
    });

    root.querySelector("[data-load-more]").addEventListener("click", function () {
      visibleLimit += pageSize;
      renderProducts(true);
    });

    grid.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-add-to-cart]");
      if (addButton) {
        addToCart(addButton.dataset.addToCart);
        return;
      }
      var detailButton = event.target.closest("[data-product-detail]");
      if (detailButton) showProduct(detailButton.dataset.productDetail);
    });

    productModalContent.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-add-to-cart]");
      if (addButton) {
        closeModal(productModal, false);
        addToCart(addButton.dataset.addToCart);
      }
    });

    root.querySelectorAll("[data-cart-open]").forEach(function (button) {
      button.addEventListener("click", openCart);
    });
    root.querySelectorAll("[data-cart-close]").forEach(function (button) {
      button.addEventListener("click", function () { closeCart(true); });
    });
    root.querySelector("[data-product-close]").addEventListener("click", function () { closeModal(productModal, true); });
    root.querySelector("[data-checkout-close]").addEventListener("click", function () { closeModal(checkoutModal, true); });
    overlay.addEventListener("click", function () { closeCart(true); });

    cartItems.addEventListener("click", function (event) {
      var removeButton = event.target.closest("[data-cart-remove]");
      if (!removeButton) return;
      cart = cart.filter(function (item) { return item.id !== removeButton.dataset.cartRemove; });
      saveCart(cart);
      renderCart();
    });

    cartItems.addEventListener("change", function (event) {
      var input = event.target.closest("[data-cart-quantity]");
      if (!input) return;
      var item = cart.find(function (candidate) { return candidate.id === input.dataset.cartQuantity; });
      var product = productById.get(input.dataset.cartQuantity);
      if (!item || !product) return;
      item.quantity = sanitizeQuantity(product, input.value);
      input.value = item.quantity;
      saveCart(cart);
      renderCart();
    });

    root.querySelector("[data-checkout-open]").addEventListener("click", function () {
      if (!cart.length) return;
      renderOrderPreview();
      openModal(checkoutModal);
    });

    if (orderForm) {
      orderForm.addEventListener("submit", renderOrderPreview);
    }

    [productModal, checkoutModal].forEach(function (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal(modal, true);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (productModal.classList.contains("is-open")) closeModal(productModal, true);
      else if (checkoutModal.classList.contains("is-open")) closeModal(checkoutModal, true);
      else if (cartDrawer.classList.contains("is-open")) closeCart(true);
    });

    renderCategories();
    renderCart();
    renderProducts(false);

    var formSuccess = root.querySelector("[data-form-success]");
    var formErrors = root.querySelector(".inventory-order-form .errors");
    if (formSuccess || formErrors) {
      openModal(checkoutModal);
      if (formSuccess) {
        formSuccess.focus();
        cart = [];
        saveCart(cart);
        renderCart();
      }
    }
  }

  function initializeAll() {
    document.querySelectorAll("[data-inventory-root]").forEach(initInventory);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.matches && event.target.matches("[data-inventory-root]")) {
      initInventory(event.target);
    } else if (event.target) {
      event.target.querySelectorAll("[data-inventory-root]").forEach(initInventory);
    }
  });
})();
